/*
 * 站外平台身份绑定。所有接口都在受 App Session 保护的 `/api/v1/app` 下。
 *
 * 同一套接口服务 QQ、B 站等平台。验证码是一次性的，
 * 明文只会在创建响应里出现，刷新页面后只能重新生成，不能从服务端取回。
 */

import { apiRequest } from "./api-client";

export type ChannelBindingStatus =
  | "awaiting_submission"
  | "pending_confirmation"
  | "active";

export interface ChannelBindingView {
  id: string;
  providerKey: string;
  platformLabel: string;
  accountDisplayName: string | null;
  status: ChannelBindingStatus;
  actorDisplayName: string | null;
  scopeLabel: string | null;
  expiresAt: string;
  submittedAt: string | null;
  confirmedAt: string | null;
  createdAt: string;
}

export interface StartedChannelBinding extends ChannelBindingView {
  /** 只在 POST 创建响应里返回。服务端数据库不保存明文。 */
  code: string;
}

export function fetchChannelBindings(signal?: AbortSignal) {
  return apiRequest<ChannelBindingView[]>("/api/v1/app/channel-bindings", {
    ...(signal ? { signal } : {}),
  });
}

export type ChannelBindingProvider = "qq_official" | "bilibili";

export function startChannelBinding(providerKey: ChannelBindingProvider) {
  return apiRequest<StartedChannelBinding>("/api/v1/app/channel-bindings", {
    method: "POST",
    body: { providerKey },
  });
}

export function confirmChannelBinding(id: string) {
  return apiRequest<ChannelBindingView>(
    `/api/v1/app/channel-bindings/${encodeURIComponent(id)}/confirm`,
    { method: "POST", body: {} },
  );
}

export function rejectChannelBinding(id: string) {
  return apiRequest<{ rejected: true }>(
    `/api/v1/app/channel-bindings/${encodeURIComponent(id)}/reject`,
    { method: "POST", body: {} },
  );
}

export function revokeChannelBinding(id: string) {
  return apiRequest<{ revoked: true }>(
    `/api/v1/app/channel-bindings/${encodeURIComponent(id)}`,
    { method: "DELETE" },
  );
}
